var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrashBin64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 15l-.04-5.26A4.24 4.24 0 0126.7 5.5h10.6a4.24 4.24 0 014.24 4.24L41.5 15",
    stroke: "currentColor",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round",
    d: "M5.5 14.5h53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 14.5h40l-.71 33.93c-.073 3.522-.46 4.793-1.167 6.072a7.263 7.263 0 01-3.02 2.958c-1.294.68-2.572 1.04-6.096 1.04H22.993c-3.524 0-4.802-.36-6.096-1.04a7.263 7.263 0 01-3.02-2.958c-.707-1.279-1.094-2.55-1.168-6.072L12 14.5h0z",
    stroke: "currentColor",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.86 13.98h40.28l-.82 34.475c-.085 3.517-.473 4.784-1.181 6.06a7.262 7.262 0 01-3.02 2.95c-1.292.676-2.569 1.035-6.087 1.035H22.968c-3.518 0-4.795-.359-6.086-1.036a7.262 7.262 0 01-3.02-2.949c-.709-1.276-1.097-2.543-1.181-6.06L11.86 13.98z",
    fillOpacity: 0.15,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round",
    d: "M24.58 25.64l2.12 21.2m12.72-21.2l-2.12 21.2"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashBin64);
export default __webpack_public_path__ + "static/media/trash-bin-64.1d4ee7bf.svg";
export { ForwardRef as ReactComponent };